/*index.js*/

import Vue from 'vue'
import vuex from 'vuex'
import vuexAlong from 'vuex-along';
Vue.use(vuex);
vuexAlong.watchSession(['state'], true);
export default new vuex.Store({
	plugins: [vuexAlong],
	//存储变量
	state: {
		clfHouse: {}, //存量房数据
		project:{},//新房项目
		room:{},//房源详情
		houseNum:{},//房源幢号
		userData: {},//用户信息
		zcfg:{},
		rentData:{},//租赁数据
		sign:{},// 保存状态 
		showForm:false,
		details:{},//装修公司数据
		jzjcList:{},
		unit:{},//单位信息
		isShowLabel:false,//是否展示房交会内容
		dzfvalue:'',//点击的否为顶账房
	},
	//获取state
	getters: {
		getIsShowLabel(state){
			return state.isShowLabel;
		},
		getDetails(state){
			return state.details;
		},
		getClfHouse(state) {
			return state.clfHouse;
		},
		getProject(state){
			return state.project;
		},
		getRoom(state){
			return state.room;
		},
		getHouseNum(state){
			return state.houseNum;
		},
		getUserData(state) {
			return state.userData;
		},
		getzcfg(state) {
			return state.zcfg;
		},
		getRentData(state) {
			return state.rentData;
		},
		getSign(state){
			return state.sign;
		},
		getShowForm(state){
			return state.showForm;
		},
		getJzjcList(state){
			return state.jzjcList;
		},
		getUnit(state){
			return state.unit;
		},
		getDzfvalue(state){
			return state.dzfvalue;
		},
	},
	/*操作多个state,异步*/
	mutations: {
		setIsShowLabel(state,isShowLabel){
			state.isShowLabel=isShowLabel;
		},
		setDetails(state,details){
			state.details=details;
		},
		setClfHouse(state, clfHouse) {
			state.clfHouse = clfHouse;
		},
		setProject(state,project){
			state.project=project;
		},
		setRoom(state,room){
			state.room = room;
		},
		setHouseNum(state,houseNum){
         state.houseNum = houseNum;
		},
		setUserData(state, userData) {
			state.userData = userData;
		},
		setzcfg(state, zcfg) {
			state.zcfg = zcfg;
		},
		setRentData(state, rentData) {
			state.rentData = rentData;
		},
		setSign(state,sign){
            state.sign = sign;
		},
		setShowForm(state,showForm){
            state.showForm = showForm;
		},
		setJzjcList(state,jzjcList){
            state.jzjcList = jzjcList;
		},
		setUnit(state,unit){
            state.unit = unit;
		},
		setDzfvalue(state,dzfvalue){
			state.dzfvalue = dzfvalue;
		}
	},
	/*操作多个state,异步*/
	actions: {
		ClickLeftMenu({ dispatch, commit, state }) {

        }
	}
});


// WEBPACK FOOTER //
// ./src/store/index.js